import axios from 'axios';

// custom axios instance with custon configuration to be used globally
export const API = axios.create({
  baseURL: process.env.REACT_APP_INTERNAL_API_HOST,
  headers: { 'Content-Type': 'application/json' },
  timeout: 120000, // 2 minutes (e.g. slow wardrobe / cache warm paths)
  withCredentials: false,
});
